// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"About_fadeIn__1ZXS8","aboutContent":"About_aboutContent__3aOnW","aboutContet":"About_aboutContet__YI7Lf","technicalChops":"About_technicalChops__1RMxY"};